import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

import { classNames } from "../../shared/utility";

const initialFValues = {
  endDate: "",
  startDate: "",
  status: "",
};

export default function SlideOver(props) {
  const { childComponent, customClass, slideOver, setSlideOver, fullScreen } =
    props;

  return (
    <Transition.Root show={slideOver.open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() =>
          setSlideOver({
            childComponent: null,
            open: false,
          })
        }
      >
        <div className="fixed inset-0 bg-[#0F172A]/20 backdrop-blur-[1px]" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className={classNames(
                "pointer-events-none fixed inset-y-0 right-0 flex max-w-full",
                fullScreen ? "pl-0" : "pl-10",
              )}
            >
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel
                  className={classNames(
                    fullScreen
                      ? "max-w-full"
                      : customClass
                        ? customClass
                        : "max-w-md",
                    "qatrace-screen pointer-events-auto h-full w-screen overflow-y-auto border-l border-[#E2E8F0] bg-white shadow-2xl",
                  )}
                >
                  {childComponent}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
